import { searchServiceCtx } from '../search/search.service.constants'

export const isHamlet = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.hamlet

export const isLandmark = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.landmark

export const isNamedPlace = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.namedPlace

export const isCountry = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.country

export const isRegion = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.admin1

export const isDepartment = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.admin7

export const isTown = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.town

export const isDistrict = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.district

export const isWay = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.way

export const isAddressPoint = ({ geocode_level } = {}) => geocode_level === searchServiceCtx.geocodeLevel.addressPoint
